import { createStyles, Stack, Text } from '@mantine/core';
import React from 'react';

export function OverviewDevices() {
  const { classes } = useStyles();

  return (
    <Stack className={classes.container}>
      <Text fz="xl">Under maintenance</Text>
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    paddingInline: theme.spacing.xxl,
  },
}));
